import { SkeletonFrame } from '@nextgen-web-framework/all';
import styles from './SkeletonLoader.module.scss';
import { SkeletonLoaderProps } from './types/propsTypes';
const SkeletonLoader = ({ isRoundCorner, ...props }: SkeletonLoaderProps) => {
  const propsObj: { [key: string]: string | number | boolean } = {};
  if (props.height) {
    propsObj['heightValue'] = `${props.height}`;
  }

  if (props.borderRadius) {
    propsObj['borderRadiusValue'] = `${props.borderRadius}`;
  }

  if (props.className) {
    propsObj['className'] = `${props.className}`;
  }

  return (
    <div className={styles['skeleton-loader-container']}>
      <SkeletonFrame isRoundCorner={isRoundCorner} {...propsObj} />
    </div>
  );
};

export default SkeletonLoader;
